// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/intakeDefaults.ts

import type { IntakeFormState } from "./types";

export const emptyIntakeForm: IntakeFormState = {
  requestFor: "",
  familyDoctorSituation: "",
  otherReasonText: "",
  coverageType: "",
  consentAccepted: "",

  preferredDoctorGender: "",
  preferredLanguageId: "",

  hccRegistered: "",
  hccReferred: "",
  hccComplexVulnerable: "",
  hccReferenceInfo: "",
  hccReferenceNote: "",
  hccReferralDate: "",

  hospitalOvernightLast3Months: "",
  dischargedWithoutFamilyDoctor: "",
  dischargeDate: "",
  dischargeDateUnknown: false,

  currentlyPregnant: "",
  pregnancy30WeeksOrMore: "",
  pregnantHasFamilyDoctor: "",
  babyLast2Weeks: "",
  newbornHasFamilyDoctor: "",
  multipleBirth: "",
  newbornNicuLast3Months: "",

  fitPositiveOrCrcFollowUp: "",
  hasDoctorArrangingCrcFollowUp: "",

  regularMedications3Plus: "",
  ongoingConditionsRegularFollowUp: "",
  troubleManagingCare: "",
  mentalHealthAddictionStressSupport: "",
  mobilityDisabilityAccessibilitySupport: "",
  helpCommunicatingEnglish: "",

  phoneBestContact: "",
  reliableEmailAccess: "",
  helpBookingOrAttending: "",

  priorityOverrideLevel: "",
  priorityOverrideReason: "",
  priorityOverrideNote: "",

  navigatorSummary: "",
  note: "",
};